import { BASE_SERVICE_URL } from '../../../lib/constants'
import type SFTP from '../interface/sftpIntegration';

interface StatusSftp{
    [uid:string]:string
}
const status = async (): Promise<StatusSftp[]> => {
    try {
        const listResult = await fetch(BASE_SERVICE_URL + `/sftp/status`, {
            credentials: 'same-origin',
        }).then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                var error = new Error(response.statusText);
                error.response = response;
                throw error;
            }
        }) as StatusSftp[]
        return listResult;
    } catch (error) {
        return []
    }
}



export default status